export const TYPE = {
  GET_FILLING_USER_DATA_FREE_VIP: 'GET_FILLING_USER_DATA_FREE_VIP',
  RANK_TEST: 'RANK_TEST',
};

export default {TYPE};
